const pageNameKey = "supportChatModal";

export const supportChatModalEn = {
  [pageNameKey]: {
    chatMessages: "Support chat messages",
    imageRemoveAlt: "Remove image",
    imagePickerLabel: "Attach images",
    imageTooMany: "You can select up to 3 images.",
    imageSizeTooLarge: "Each image must be smaller than 5MB.",
    imageInvalidType: "Please select image files (JPEG, PNG or WebP).",
    thinkingBubbleText: "Thinking...",
    markAsDoneButton: "Mark as done",
    humanSupportButton: "Human support",
    handoverText:
      "We're handing this over to the human support team. Someone will take a look and follow up with you shortly.",
    errorStreamAnswer: "Sorry, something went wrong.",
  },
};

export const supportChatModalPtBr = {
  [pageNameKey]: {
    chatMessages: "Mensagens do chat de suporte",
    imageRemoveAlt: "Remover imagem",
    imagePickerLabel: "Anexar imagens",
    imageTooMany: "Você pode selecionar até 3 imagens.",
    imageSizeTooLarge: "Cada imagem deve ter menos de 5MB.",
    imageInvalidType: "Selecione arquivos de imagem (JPEG, PNG ou WebP).",
    thinkingBubbleText: "Pensando...",
    markAsDoneButton: "Marcar como concluído",
    humanSupportButton: "Atendimento humano",
    handoverText:
      "Estamos encaminhando isso para a equipe de suporte humano. Alguém analisará o caso e entrará em contato com você em breve.",
    errorStreamAnswer: "Desculpe, algo deu errado.",
  },
};

export const supportChatModalDe = {
  [pageNameKey]: {
    chatMessages: "Support-Chat-Nachrichten",
    imageRemoveAlt: "Bild entfernen",
    imagePickerLabel: "Bilder anhängen",
    imageTooMany: "Du kannst bis zu 3 Bilder auswählen.",
    imageSizeTooLarge: "Jedes Bild muss kleiner als 5MB sein.",
    imageInvalidType: "Bitte wähle Bilddateien (JPEG, PNG oder WebP) aus.",
    thinkingBubbleText: "Denke nach...",
    markAsDoneButton: "Als erledigt markieren",
    humanSupportButton: "Menschlicher Support",
    handoverText:
      "Wir übergeben dies an das menschliche Support-Team. Jemand wird sich das ansehen und sich in Kürze bei Ihnen melden.",
    errorStreamAnswer: "Entschuldigung, etwas ist schief gelaufen.",
  },
};

export const supportChatModalZhHans = {
  [pageNameKey]: {
    chatMessages: "支持聊天消息",
    imageRemoveAlt: "移除图片",
    imagePickerLabel: "附加图片",
    imageTooMany: "最多可以选择3张图片。",
    imageSizeTooLarge: "每张图片必须小于5MB。",
    imageInvalidType: "请选择图片文件（JPEG、PNG 或 WebP）。",
    thinkingBubbleText: "思考中...",
    markAsDoneButton: "标记为完成",
    humanSupportButton: "人工支持",
    handoverText:
      "我们将把此问题转交给人工支持团队。团队成员会尽快查看并跟进。",
    errorStreamAnswer: "抱歉，出了点问题。",
  },
};

export const supportChatModalIt = {
  [pageNameKey]: {
    chatMessages: "Messaggi della chat di supporto",
    imageRemoveAlt: "Rimuovi immagine",
    imagePickerLabel: "Allega immagini",
    imageTooMany: "Puoi selezionare fino a 3 immagini.",
    imageSizeTooLarge: "Ogni immagine deve essere inferiore a 5MB.",
    imageInvalidType: "Seleziona file immagine (JPEG, PNG o WebP).",
    thinkingBubbleText: "Sto pensando...",
    markAsDoneButton: "Problema risolto",
    humanSupportButton: "Richiedi operatore",
    handoverText:
      "Stiamo trasferendo la richiesta al team di supporto umano. Qualcuno la esaminerà e ti ricontatterà a breve.",
    errorStreamAnswer: "Spiacenti, qualcosa è andato storto.",
  },
};

export const supportChatModalEs = {
  [pageNameKey]: {
    chatMessages: "Mensajes del chat de soporte",
    imageRemoveAlt: "Eliminar imagen",
    imagePickerLabel: "Adjuntar imágenes",
    imageTooMany: "Puedes seleccionar hasta 3 imágenes.",
    imageSizeTooLarge: "Cada imagen debe tener menos de 5MB.",
    imageInvalidType: "Selecciona archivos de imagen (JPEG, PNG o WebP).",
    thinkingBubbleText: "Pensando...",
    markAsDoneButton: "Marcar como hecho",
    humanSupportButton: "Soporte humano",
    handoverText:
      "Estamos transfiriendo esto al equipo de soporte humano. Alguien lo revisará y se pondrá en contacto contigo en breve.",
    errorStreamAnswer: "Lo siento, algo salió mal.",
  },
};

export const supportChatModalNl = {
  [pageNameKey]: {
    chatMessages: "Supportchatberichten",
    thinkingBubbleText: "Denkt na...",
    errorStreamAnswer: "Sorry, er is iets misgegaan.",
    imageRemoveAlt: "Afbeelding verwijderen",
    imagePickerLabel: "Afbeeldingen bijvoegen",
    imageTooMany: "Je kunt maximaal 3 afbeeldingen selecteren.",
    imageSizeTooLarge: "Elke afbeelding moet kleiner zijn dan 5MB.",
    imageInvalidType: "Selecteer afbeeldingsbestanden (JPEG, PNG of WebP).",
    thinkingBubbleLongText:
      "Denkt na... Ik heb het momenteel een beetje druk. Ik ontvang veel berichten.",
    thinkingBubbleShortText: "Denkt na",
    thinkingBubbleIconAlt: "Chatbot",
    markAsDoneButton: "Markeren als voltooid",
    humanSupportButton: "Menselijke ondersteuning",
    handoverText:
      "We dragen dit over aan het menselijke supportteam. Iemand bekijkt het en neemt binnenkort contact met je op.",
  },
};

export const supportChatModalTr = {
  [pageNameKey]: {
    chatMessages: "Destek sohbeti mesajları",
    imageRemoveAlt: "Görseli kaldır",
    imagePickerLabel: "Görsel ekle",
    imageTooMany: "En fazla 3 görsel seçebilirsiniz.",
    imageSizeTooLarge: "Her görsel 5 MB'tan küçük olmalıdır.",
    imageInvalidType: "Lütfen JPEG, PNG veya WebP biçiminde görsel seçin.",
    errorStreamAnswer: "Üzgünüz, bir şeyler ters gitti.",
    humanSupportButton: "İnsan desteği",
    handoverText:
      "Bunu insan destek ekibine aktarıyoruz. Bir ekip üyesi inceleyip kısa süre içinde sizinle iletişime geçecek.",
    markAsDoneButton: "Tamamlandı olarak işaretle",
    thinkingBubbleText: "Düşünüyorum...",
  },
};
